import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ToolService } from '@app/core/services/tool/tool.service';
import { faQuestionCircle, faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SafePipe } from '@app/shared/pipes/safe/safe.pipe';

@Component({
    selector: 'app-application-information-tooltip',
    templateUrl: './application-information-tooltip.component.html',
    styleUrls: ['./application-information-tooltip.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule, SafePipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ApplicationInformationTooltipComponent {
    icons = {
        question: faQuestionCircle,
        infocircle: faInfoCircle,
    };
    @Input() type: string;
    @Input() icon: string;
    @Input() userEmail: string;
    constructor(public toolService: ToolService) {}
}
